<template>
  <b-modal :active.sync="opened" :full-screen="isFullScreen" width="500px">
    <div class="card">
      <div class="card-image">
        <vue-cropper
          ref="cropper"
          alt="Source Image"
          :src="value"
          :aspect-ratio="aspectRatio"
          :initial-aspect-ratio="initialAspectRatio"
          :view-mode="1"
        >
        </vue-cropper>
      </div>
      <div class="card-content">
        <div class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <b-button
              :loading="isCropping"
              :disabled="isCropping"
              @click="crop"
              type="is-primary"
              >Save</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import ModalMixin from '@/utils/mixins/modal'

export default {
  mixins: [ModalMixin],
  components: {
    VueCropper
  },
  props: {
    aspectRatio: {
      default: 1 / 1
    },
    initialAspectRatio: {
      default: 1 / 1
    }
  },
  data() {
    return {
      isCropping: false,
      opened: false,
      value: null
    }
  },
  methods: {
    open(file) {
      this.opened = true
      this.value = file
    },
    close() {
      this.value = null
      this.isCropping = false
      this.opened = false
    },
    crop() {
      this.isCropping = true
      this.$refs.cropper.getCroppedCanvas().toBlob(blob => {
        this.isCropping = false
        this.$emit('change', blob)
        this.close()
      })
    }
  }
}
</script>
